import { cva } from 'class-variance-authority';

export const flag = cva('text-color-text-light absolute font-bold', {
  variants: {
    size: {
      large: 'text-size-headline-3xl ml-2',
      normal: 'text-size-headline-2xl ml-[10px]',
      small: 'text-size-headline-base ml-1.5',
    },
  },
  defaultVariants: { size: 'normal' },
});
